import { type MouseEventHandler } from 'react';
import SearchIcon from 'assets/icons/search.svg';
import styles from './search-button.module.scss';

function SearchButton({
	handleClick,
}: {
	handleClick: MouseEventHandler<HTMLButtonElement>;
}) {
	return (
		<button
			aria-label="Search Button"
			title="Search Button"
			type="button"
			onClick={handleClick}
		>
			<SearchIcon
				className={styles.icon}
				data-testid="search-icon"
				aria-hidden="true"
			/>
		</button>
	);
}

export { SearchButton };
